// extracted by mini-css-extract-plugin
export default {"wrapper":"wxQnYJEdRwerWmViKc9Wjw=="};